<div class="nombreGateway" *ngIf="gatewayActual">
  <h3>
    <b>Mostrando informacion de la pasarela:</b> {{ gatewayActual.nombre }}
  </h3>
</div>

<br />
<div style="text-align: left" class="row">
  <a style="margin-left: 2vw; cursor: pointer" (click)="previousState()">
    <i class="material-icons">chevron_left</i>
  </a>
</div>

<div class="basic-container" *ngIf="gatewayActual">
  <div
    fxLayout.xs="column"
    fxLayout="row wrap"
    fxLayoutGap="10px"
    ngClass.gt-xs="ml-1"
  >
    <mat-card
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
      [hidden]="dataSourceFrom?.data.length == 0"
    >
      <mat-card-content>
        <table mat-table [dataSource]="dataSourceFrom">
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>
              <h4>
                <b style="color: black">
                  <span style="text-align: left"
                    >Gateways de los que cuelga</span
                  >
                </b>
              </h4>
            </th>
            <td
              mat-cell
              *matCellDef="let d; let i = index"
              ngxClipboard
              [cbContent]="d.from.nombre"
              (cbOnSuccess)="copiado($event)"
            >
              <span matBadge="{{ i }}" matBadgeOverlap="true"
                ><i class="material-icons alarm">new_releases</i></span
              >

              <a
                style="padding-left: 25px"
                title="Navegar a {{ d.from.nombre }}"
                [routerLink]="['/gateways', d.from.uuid]"
              >
                {{ d.from.nombre }}
              </a>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumnsFrom"></tr>
          <tr
            mat-row
            class="pre"
            *matRowDef="let row; columns: displayedColumnsFrom"
          ></tr>
        </table>
      </mat-card-content>
    </mat-card>

    <mat-card
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-title>
        Información
        <a
          style="cursor: pointer; padding: 7px"
          (click)="openDialog()"
          title="Editar información del nodo"
        >
          <mat-icon>edit_note</mat-icon>
        </a>
        <mat-icon
          class="alarms"
          matBadge="{{ sourcesDownCount + gatewaysToDownCount }}"
          (click)="openAlertsComponent('alarmado')"
          title="Incidencias alarmadas en la estructura"
          >new_releasess</mat-icon
        >
        <mat-icon
          class="silenced"
          matBadge="{{ nodesSilencedsArray.length }}"
          (click)="openAlertsComponent('silenciado')"
          title="Incidencias silenciadas en la estructura"
          >notifications_off</mat-icon
        >
        <mat-icon
          class="others"
          (click)="rearmaAlarmaNodo()"
          title="Otras incidencias"
          >notifications_active</mat-icon
        >
      </mat-card-title>
      <mat-card-subtitle>Características de la pasarela</mat-card-subtitle>
      <mat-card-content>
        <span *ngFor="let tps of gatewayActual.labels; last as isLast">
          <span *ngIf="!tps.endsWith('Aux')">
            <b>{{ tps || "Sin label asignado" }}</b>
          </span>
          <span *ngIf="!isLast">&nbsp;</span>
        </span>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="lmPing"
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-title>Comunicación concentrador</mat-card-title>
      <mat-card-subtitle
        >Último ping:
        <span *ngIf="lmPing.alive.lastValor === 'true'; else errorBlock">
          <i class="material-icons ok" title="último ping exitoso"> done </i>
        </span>
        <span
          [ngClass]="
            lmPing.alive.lastEntrada.lastValor === 'true'
              ? 'ping-alive'
              : 'ping-dead'
          "
        >
          <b> {{ lmPing.alive.lastFecha | getDatePipe }}</b>
        </span>
        <span *ngIf="lmPing.alive.lastValor === 'true'">
          (Estado correcto)
        </span>
        <span *ngIf="lmPing.alive.lastValor === 'false'">
          (No ha respondido al último ping)
        </span>
      </mat-card-subtitle>
      <mat-card-content>
        Host: <b>{{ lmPing.host }} </b>
        <i
          class="material-icons copy"
          ngxClipboard
          [cbContent]="lmPing.host"
          (cbOnSuccess)="copiado($event)"
          title="Copiar la IP del host al portapapeles"
        >
          file_copy
        </i>
      </mat-card-content>
    </mat-card>

    <mat-card
      *ngIf="lmPing"
      fxFlex.sm="0 1 calc(50%-10px)"
      fxFlex.md="0 1 calc(33%-10px)"
      fxFlex.gt-md="0 1 calc(25%-10px)"
    >
      <mat-card-title>Salud del concentrador</mat-card-title>
      <mat-card-subtitle
        >Tiempo medio de respuesta (última semana)</mat-card-subtitle
      >
      <mat-card-content>
        <app-graphql-ts
          [title]="null"
          [graphConfig]="graphConfig"
        ></app-graphql-ts>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #errorBlock>
  <i class="material-icons warning" title="Último ping erróneo"> warning </i>
</ng-template>

<div [hidden]="dataSourceTo?.data.length == 0">
  <hr style="margin-left: 2vw; margin-top: 25px; width: 85%" />
  <br />
  <div *ngIf="gatewayActual">
    <h1 class="tituloTabla">
      Pasarelas dentro de {{ gatewayActual.nombre }}
      <button
        mat-raised-button
        color="primary"
        matBadgeColor="warn"
        [matBadge]="gatewaysToDownCount"
        (click)="
          filterTable(
            'filter',
            'dataSourceTo',
            'alarmadosCount',
            '>',
            0,
            $event
          )
        "
      >
        Mostrar puntos alarmados
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="filterTable('showFullTable', 'dataSourceTo')"
        style="margin-left: 15px"
      >
        Mostrar tabla completa
      </button>
    </h1>
  </div>
  <br />

  <mat-form-field class="filtro-tabla">
    <mat-label>Filtrar</mat-label>
    <input
      matInput
      (keyup)="applyFilterTo($event)"
      placeholder="Filtrar datos..."
    />
  </mat-form-field>

  <div
    class="mat-elevation-z8"
    style="width: 85%; margin-left: 2vw"
    align="center"
  >
    <table mat-table [dataSource]="dataSourceTo">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
        <td mat-cell *matCellDef="let d">
          <span
            *ngIf="d.alarmadosCount"
            matBadge="{{ d.alarmadosCount }}"
            matBadgeOverlap="true"
            ><i class="material-icons alarm">new_releases</i></span
          >

          <a
            style="padding-left: 25px"
            title="Navegar a {{ d.data.nombre }}"
            [routerLink]="['/gateways', d.data.uuid]"
          >
            {{ d.data.nombre }}
          </a>
          <i
            class="material-icons copy"
            ngxClipboard
            [cbContent]="d.data.uuid"
            (cbOnSuccess)="copiado($event)"
            title="Copiar el uuid del gateway {{ d.data.nombre }}"
          >
            file_copy
          </i>
        </td>
      </ng-container>
      <ng-container matColumnDef="last">
        <th mat-header-cell *matHeaderCellDef><b>Último dato recibido</b></th>
        <td mat-cell *matCellDef="let d">
          {{
            (d.data.lastSource?.lastEntrada?.lastFecha | getDatePipe) ||
              "No existe fecha de recepción de datos"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sources">
        <th mat-header-cell *matHeaderCellDef><b>Sources rezagados</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.sourcesRezagados || 0 }} / {{ d.data.sourcesTotal || 0 }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsTo"></tr>
      <tr
        mat-row
        class="pre"
        *matRowDef="let row; columns: displayedColumnsTo"
      ></tr>
      <!-- [ngClass]="{'trError': (row.alarmadosCount > 0), 'trWarning' : (row.silenciadosCount >0)}" -->
    </table>
    <mat-paginator
      #TableToPaginator="matPaginator"
      [pageSizeOptions]="[15, 30, 50]"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>

<ng-template #elseBlock>
  <i
    class="material-icons warning"
    title="Existen sources rezagados en el gateway"
  >
    warning
  </i>
</ng-template>

<div [hidden]="dataSourceSources && dataSourceSources?.data.length == 0">
  <hr style="margin-left: 2vw; margin-top: 25px; width: 85%" />
  <br />

  <div *ngIf="gatewayActual">
    <h1 class="tituloTabla">
      Fuentes de datos dentro de {{ gatewayActual.nombre }}
      <button
        mat-raised-button
        color="primary"
        matBadgeColor="warn"
        [matBadge]="sourcesDownCount"
        (click)="
          filterTable(
            'filter',
            'dataSourceSources',
            'alarmadosCount',
            '>',
            0,
            $event
          )
        "
      >
        Mostrar puntos alarmados
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="filterTable('showFullTable', 'dataSourceSources')"
        style="margin-left: 15px"
      >
        Mostrar tabla completa
      </button>
    </h1>
  </div>
  <br />

  <mat-form-field class="filtro-tabla">
    <mat-label>Filtrar</mat-label>
    <input
      matInput
      (keyup)="applyFilterSources($event)"
      placeholder="Filtrar datos..."
    />
  </mat-form-field>

  <div
    class="mat-elevation-z8"
    style="width: 85%; margin-left: 2vw"
    align="center"
  >
    <table mat-table [dataSource]="dataSourceSources">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef><b>Nombre</b></th>
        <td mat-cell *matCellDef="let d; let i = index">
          <span
            *ngIf="d.alarmadosCount"
            matBadge="{{ d.alarmadosCount || 0 }}"
            matBadgeOverlap="true"
            ><i class="material-icons alarm">new_releases</i></span
          >

          <a
            style="padding-left: 25px"
            title="Navegar al source {{ d.data.nombre }}"
            [routerLink]="['/source', d.data.uuid]"
          >
            {{ d.data.nombre }}
          </a>
          <i
            class="material-icons copy"
            ngxClipboard
            [cbContent]="d.data.uuid"
            (cbOnSuccess)="copiado($event)"
            title="Copiar el uuid del source"
          >
            file_copy
          </i>
        </td>
      </ng-container>

      <ng-container matColumnDef="topic">
        <th mat-header-cell *matHeaderCellDef><b>Topic</b></th>
        <td mat-cell *matCellDef="let d">
          <div style="width: 85%; word-wrap: break-word">
            {{ d.data.topic }}
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="entradas">
        <th mat-header-cell *matHeaderCellDef>
          <b>Entradas rezagadas (con datos)</b>
        </th>
        <td mat-cell *matCellDef="let d">
          <span
            *ngIf="
              d.entradasNulas != d.data.entradasConnection.edges.length;
              else sinFechasBlock
            "
          >
            {{ d.entradasRezagadas }} / {{ d.countNotNull }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef><b>Modelo</b></th>
        <td mat-cell *matCellDef="let d">
          {{ d.modelo || "Sin modelo" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsSources"></tr>
      <tr
        mat-row
        class="pre"
        *matRowDef="let row; columns: displayedColumnsSources"
      ></tr>
      <!-- [ngClass]="{'trError': (row.alarmadosCount > 0), 'trWarning' : (row.silenciadosCount >0)}"  -->
    </table>
    <mat-paginator
      #TableSourcesPaginator="matPaginator"
      [pageSizeOptions]="[15, 30, 50]"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>

<br />

<div align="center" *ngIf="dataSourceFrom?.data.length == 0  && dataSourceTo?.data.length == 0 && dataSourceSources?.data.length ==0">
    <app-svg name="block-icon"></app-svg>
</div>

<ng-template #sinFechasBlock>
  Ninguna entrada tiene fecha de envío
</ng-template>
